import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {RestService} from "../../services/rest.services.service";
import {capturarFile, convertirPrimeraLetraMayuscula, validateSizeFile} from "../../utils/utilities";
import {ServiceNotificationService} from "../../services/service-notification.service";
import {DomSanitizer} from "@angular/platform-browser";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {environment} from "../../../environments/environment";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {NotificationsComponent} from "../../notifications/notifications.component";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {HttpHeaders} from "@angular/common/http";


@Component({
  selector: 'app-main-screen',
  standalone: true,
  imports: [
    NotificationsComponent,
    RouterLink,
    NgIf,
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './main-screen.component.html',
  styleUrl: './main-screen.component.css'
})
export class MainScreenComponent implements OnInit {

  public archivos: any = [];
  @ViewChild('inputXML') inputXML!: ElementRef;
  @ViewChild('inputPDF') inputPDF!: ElementRef;
  @ViewChild('botonEnviar') botonEnviar!: ElementRef;
  @ViewChild('modalNothing') modalNothing!: ElementRef;
  previewImage: any;
  formDataOfDocument: FormGroup = new FormGroup({});
  codigoOrden: any = null;
  isDisabled: boolean = false;
  nombreProveedor: string = '';
  totalPagarFactura: number = 0;
  codOrden : number = 0;
  hashedPassword  : string | null='';
  validateOrden: boolean = false;
  ordenIsValid: boolean = false;
  ordenIsClosed: boolean = false;
  checkXML: boolean = false;
  checkPDF: boolean = false;
  pagosAutomaticos: number = 0;
  pagoPE: number = 0;
  saldoPendiente: number = 0.0;
  listDocuments: any = [];
  numeroDocumento: string = '';
  headers: HttpHeaders= new HttpHeaders;
  totalSuma = 0;


  constructor(
    private route: ActivatedRoute,
    private restService: RestService,
    private serviceNotifications: ServiceNotificationService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private rendered: Renderer2
  ) {
  }

  async ngOnInit() {

    this.route.paramMap.subscribe(async params => {
      try {


        this.setCodigoAndHash();


      } catch (error) {
        console.error("Error:" + error);
      }



      this.validateDataOfOrdenFunction();

      // const isOrdenValid = await this.validateDataOfOrden(this.hashedPassword, this.codigoOrden);

    });









    this.formDataOfDocument = this.fb.group({
      codigoOrden: ['', [Validators.required]],
      documentXml: ['', [Validators.required]],
      routePdf: ['', [Validators.required]],
    });


  }



  setCodigoAndHash(){

    const result = this.extracDataOfUrl(
      window.location.href
    );
    console.log(result)
    const {codigoOrden, hashedPassword} = result;
    if(result){
      this.codigoOrden = codigoOrden;
      this.hashedPassword = hashedPassword;
    }
    // this.codigoOrden = this.formDataOfDocument.get('codigoOrden')?.value;
    // this.hashedPassword = this.hashedPassword;

  }





  validateDataOfOrdenFunction = async() =>{
    // console.log(this.hashedPassword)
    // console.log(this.codigoOrden)
    if (this.hashedPassword != null) {
      this.hashedPassword = decodeURIComponent(this.hashedPassword);
    }
    const isOrdenValid = await this.validateDataOfOrden(this.hashedPassword, this.codigoOrden);

    if (this.codigoOrden !== null && isOrdenValid) {
      if (!this.codigoOrden) {
        this.disableButton();
        return;
      } else {
        this.obtenerDataOfOrden(this.codigoOrden);
      }

    }
  }





  capturarArchivo(event: Event, element: string, codigoOrden: number): void {
    const input = event.target as HTMLInputElement;
    let validate;
    if (input && input.files) {
      for (let i = 0; i < input.files.length; i++) {
        validate= validateSizeFile(input.files[i].size);
        if (!validate) {
          this.mostrarToast('El tamaño de los documentos no puede ser mayor a 5MB', false);
          if (element === 'xml') {
            this.cleanFiles();
          }else {
            this.cleanFiles();

          }
          return;
        }
      }
    }
    capturarFile(event, this.sanitizer, this.archivos,(preview) => this.previewImage = preview);

    // this.validateDataOfOrdenFunction();
  }


  cleanFiles(): void {
    this.archivos = [];
    this.previewImage = null;
    this.inputXML.nativeElement.value = '';
    this.inputPDF.nativeElement.value = '';
    this.checkXML = false;
    this.checkPDF = false;
  }

  enableButton(): void {
    this.isDisabled = false;
  }
  disableButton(): void {
    this.isDisabled = true;
  }


  async validateDataOfOrden(hashedPassword: null | string, codOrden: string): Promise<boolean> {
    if (!hashedPassword || !codOrden) {
      console.error('No se pudo validar la orden. Datos faltantes.');
      return false;
    }
    return new Promise((resolve) => {
      this.restService.post({
        body: {
          hashedPassword: hashedPassword,
          codigoOrden: codOrden,
          isValid: null,
          isClosed: null
        },
        url: environment.apiCheckUrl,
      }).subscribe((res: any) => {
        // const
        const {closed, valid, pagosA, pagosPE, saldoPendiente, listOdDocuments} = res;
        console.log(res)

        this.ordenIsValid = valid;
        this.ordenIsClosed = closed;
        this.pagosAutomaticos = pagosA;
        this.pagoPE = pagosPE;
        this.saldoPendiente = saldoPendiente;
        if (listOdDocuments){
          this.listDocuments = JSON.parse(listOdDocuments).filter((doc: any) => doc?.statusFactura === true);
        }else {
          this.listDocuments = [];
        }
        this.totalSuma = 0;
        this.listDocuments.forEach((doc: any) => {
          this.totalSuma = doc.valorFactura + this.totalSuma;
        });
        if(!valid){
          this.mostrarToast('El código de la orden no es válido', false);
        }

        if (closed){
          this.mostrarToast('La orden ya se encuentra completa', false);
        }


        resolve(valid); // Resolvemos la Promise con el valor de `res.valid`
      }, (error) => {
        console.error('Error en la validación de la orden:', error);
        resolve(false); // En caso de error, asumimos que no es válida
      });
    });
  }


  obtenerDataProveedor(cod_proveedor: number){
    this.restService.post(
      {
      body: {
        id: cod_proveedor
      },
      url: environment.apiGetDataOfProveedor
    }) .subscribe((res: any)=>{
      const  { nombreComercial } = res;
      console.log(nombreComercial)
      this.nombreProveedor = convertirPrimeraLetraMayuscula(nombreComercial);
    })

  }

  deleteDocument(hashedPassword: null | string, codOrden: string, codDocumento: string){ {
    this.restService.post({
      body: {
        hashedPassword: hashedPassword,
        codigoOrden: codOrden,
        codDocumento: codDocumento
      },
      url: environment.apiDeleteDocument
    }).subscribe((res: any) => {
      const {statusDelete}= res;
      statusDelete ? this.mostrarToast('Documento eliminado correctamente.', true)  : this.mostrarToast('La factura está en proceso de pago.', false);
      this.setCodigoAndHash();
      this.validateDataOfOrdenFunction();
      this.cleanFiles();

    },
      error => {
        console.error('Error al eliminar el documento', error);
        this.mostrarToast('Error al eliminar el documento', false);
        this.cleanFiles();

      })
  }};



  obtenerDataOfOrden(codOrden: number){
    this.codOrden= codOrden;
    this.restService.post(
      {
        body: {
          id: codOrden
        },
        url: environment.apiGetDataOfOrden
      })
      .subscribe((res: any) => {
        if (res.cod != 200){
          this.mostrarToast('Error al obtener la información de la orden', false);
          this.disableButton();
          return;
        }

        const {cod_proveedor, total } = res;
        let codProveedor;
        codProveedor = cod_proveedor;
        this.totalPagarFactura = total;
        if (codProveedor){
          this.obtenerDataProveedor(codProveedor)
        }

        this.enableButton();
        this.formDataOfDocument.patchValue({
          codigoOrden: this.codOrden
        });
      });
  }






  mostrarToast(message: string, type: boolean) {
    this.serviceNotifications.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }






  sendFiles(): void {

    try{
      const headers = new HttpHeaders({
        'codOrden': this.codOrden,
        'valorFacturaInput': this.totalPagarFactura,
        'numeroDocumento': this.numeroDocumento,
      })
      console.log(this.archivos.length)

      if (this.archivos.length != 2 ) {
        this.cleanFiles();
        this.mostrarToast('Debe seleccionar los archivos.', false);
        return;
      }


      const files = new FormData();
      this.archivos.forEach((archivo: any) => {
        files.append('files', archivo);
      });
      files.append('codigoOrden', this.codigoOrden);
      this.restService.postJava({
        url: environment.apiUploadDocuments,
        body: files,
        options: {
          headers
        }
      })
        .subscribe((res: any) => {

          console.log(res)
          if (res.cod == 200) {

            this.mostrarToast('Documentos subidos correctamente', true);
            this.setCodigoAndHash();
            this.validateDataOfOrdenFunction();
            this.inputXML.nativeElement.value = '';
            this.inputPDF.nativeElement.value = '';

          } else if(res.cod == 409){
            this.mostrarToast(`${res.message}`, true);
            this.inputXML.nativeElement.value = '';
            this.inputPDF.nativeElement.value = '';
            this.validateDataOfOrdenFunction()
          }else if (res.cod == 0){
            this.mostrarToast(`${res.message}`, false);
            return;
          }else{
            this.mostrarToast(`${res.message}`, false);
            this.inputXML.nativeElement.value = '';
            this.inputPDF.nativeElement.value = '';
          }


        },error => {

          console.log(error)

            console.error('Error al subir el documento', error);
            this.mostrarToast('Error al subir el documento, por favor clic en actualizar.', false);
            this.inputXML.nativeElement.value = '';
            this.inputPDF.nativeElement.value = '';
            this.cleanFiles();


        });

    }catch (error){
      console.error('Error al enviar los documentos', error);
    }


  }

  extracDataOfUrl(url: string) {
    const processUrl = () => {
      const currentUrl = url;

      const start = currentUrl.indexOf("uploadDocuments/") + "uploadDocuments/".length;

      const remainingPath = currentUrl.substring(start);

      const segments = remainingPath.split("/");

      const codigoOrden = segments.pop() || ""; // Si no existe, devolverá un string vacío

      const hashedPassword = segments.join("/");

      if (!hashedPassword || !codigoOrden) {
        throw new Error("No se pudo procesar la URL correctamente. Datos faltantes.");
      }

      return { hashedPassword, codigoOrden };
    };

    return processUrl();
  }

 async extractTotal(event: Event) {
    const xmlInput = event.target as HTMLInputElement;
    if(!xmlInput.files?.length) return;

    const file = xmlInput.files[0];

    if(file.type !== 'text/xml') {
      console.error('El archivo no es un XML');
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const xml = e.target?.result as string;
      getXmlValue(xml, 'total').then((total) => {
        if (total === null) {
          this.mostrarToast('No pudimos obtener el total de la factura. Por favor, verifica que el archivo sea el correcto e inténtalo de nuevo.', false);
          this.inputXML.nativeElement.value = '';
          return;
        }
        this.totalPagarFactura = parseFloat(total);
      });
      this.numeroDocumento = await getNumeroFactura(xml);
    };
    reader.readAsText(file);
  }

  // protected readonly alertId = alertId;
  refreshPage() {
    window.location.reload();
  }

  setTrueXML(event: Event) {
    const input = event.target as HTMLInputElement;
    //Validar si el archivo seleccionado es tipo xml
    if (input.files && input.files[0].type !== 'text/xml' ) {
      this.mostrarToast('El archivo seleccionado no es un XML', false);
      this.inputXML.nativeElement.value = '';
      this.checkXML = false;
      return;
    }
    this.checkXML = true;

  }
  setTruePDF(event: Event) {
    const input = event.target as HTMLInputElement;
    //Validar si el archivo seleccionado es tipo pdf
    if (input.files && input.files[0].type !== 'application/pdf') {
      this.mostrarToast('El archivo seleccionado no es un PDF', false);
      this.inputPDF.nativeElement.value = '';
      this.checkPDF = false;
      return;
    }


    this.checkPDF = true;
  }
}

async function getNumeroFactura(xml: string): Promise<string> {
  let estab= await getXmlValue(xml, 'estab');
  let ptoEmi= await getXmlValue(xml, 'ptoEmi');
  let secuencial= await getXmlValue(xml, 'secuencial');
  if (!estab || !ptoEmi || !secuencial) {
    return '';
  }

  return estab + '-' + ptoEmi + '-' + secuencial;


}

async function getXmlValue(this: any, xml: string, tag: string): Promise<string | null> {
  const regex = new RegExp(`<${tag}>(.*?)</${tag}>`, 'i'); // Expresión regular para encontrar la etiqueta
  const match = xml.match(regex);
  return  match ? match[1] : null;
}



